import IconButton from "app/components/IconButton";
import { CrossIcon } from "app/components/Icons";
import Input from "app/components/Input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import clsx from "clsx";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import TagsColorPicker from "./TagsColorPicker";
import { selectLoading, selectTagsForm } from "./redux/selector";
import { actions } from "./redux/slice";
import { AddNewTagProps } from "./types";

const AddNew: React.FC<AddNewTagProps> = ({
  trigger,
  projectId,
  open,
  setOpen,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const [showFixedColor, setShowFixedColor] = React.useState(false);
  const {  color, title } = useSelector(selectTagsForm);

  const onCreate = () => {
    dispatch(
      actions.createTags({
        callback: () => {
          handleClose();
        },
      }),
    );
  };

  const handleClose = () => {
    dispatch(actions.clearForm());
    setOpen(false);
  };
  const onOpenChange = (open: boolean) => {
    dispatch(actions.clearForm());
    setOpen(open);
  };

  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Escape") {
        (e.currentTarget as HTMLInputElement).blur();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        onCreate();
      }
    },
    [onCreate],
  );

  const handleChange = (key: string, value: string) => {
    dispatch(actions.updateFormValue({ key: key, value: value }));
    dispatch(actions.updateFormValue({ key: "projectId", value: projectId }));
  };
  return (
    <div className=" relative ">
      <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          alignOffset={30}
          sideOffset={0}
          className={`!px-0 !py-1 bg-white border border-secondary cursor-pointer rounded `}
        >
          <Input
            id="value"
            inputClassName="border-gray-100 "
            name="title"
            value={title}
            onChange={(e) => handleChange("title", e.target.value)}
            onKeyDown={handleInputKeyDown}
            noBorder
            icon={
              <TagsColorPicker
                trigger={
                  <div
                    className={clsx(
                      " rounded-full flex justify-center items-center size-5",
                      showFixedColor && "border",
                    )}
                    style={{ borderColor: showFixedColor ? color : "" }}
                  >
                    <div
                      className="w-[16px] h-[16px] rounded-full cursor-pointer"
                      style={{ background: color }}
                    />
                  </div>
                }
                selectedColor={color}
                updateCode={(val) => handleChange("color", val)}
                open={showFixedColor}
                setOpen={setShowFixedColor}
              />
            }
            endIcon={
              <div className="flex justify-end items-center gap-1.5 ">
                <IconButton
                  className={clsx(
                    "border-0 ",
                    title?.length === 0 && " opacity-50 ",
                  )}
                  onClick={onCreate}
                  loading={loading}
                />
                <button onClick={() => handleClose()} disabled={loading}>
                  <CrossIcon color="#79808A" />
                </button>
              </div>
            }
            maxLength={100}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default AddNew;
